// The folder of 3D illustrations the IA index pages (Learn, Plan, …) title their pages and tiles with.
export const INDEX_ILLUSTRATIONS = '/images/kui/unified/index';
